<ng-container *ngIf="!split;else splitted">
    <span class="{{classes}} {{extraClasses}}">{{tag}}</span>
</ng-container>
<ng-template #splitted>
    <span class="{{classes}} {{extraClasses}}" *ngFor="let t of tag">{{t.CategoryName}}</span>
</ng-template>
